import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { TemplatesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [TemplatesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class TemplatesServiceModule {}
